@if (report != null) {
  @for (learner of report.learners; track learner.studentId + '-' + learner.placementId) {
    <div class="milpr-learner">

      <div class="milpr-header">
        <h3>{{learner.studentFirstName}} {{learner.studentLastName}}</h3>
        <div class="milpr-header-grid">
          <div><strong>Client:</strong> {{learner.clientName}}</div>
          <div><strong>Tutor:</strong> {{learner.tutorName}}</div>
          <div><strong>Subject:</strong> {{learner.subject}}</div>
          <div><strong>Reporting period:</strong> {{report.startDate | date:'dd/MM/yyyy'}} – {{report.endDate | date:'dd/MM/yyyy'}}</div>
          @if (learner.isGroup) { <div><strong>Group:</strong> {{learner.groupName}}</div> }
        </div>
      </div>

      <h4>Individual Learning Plan / Baseline</h4>
      @if (learner.ilps.length === 0) { <p class="milpr-empty">No ILP recorded.</p> }
      @for (ilp of learner.ilps; track $index) {
        <div class="milpr-block">
          <div><strong>Baseline date:</strong> {{ilp.baselineDate | date:'dd/MM/yyyy'}}</div>
          <div><strong>Learning plan:</strong> {{ilp.individualLearningPlan}}</div>
          <div><strong>Target:</strong> {{ilp.targetDescription}}</div>
          @if (ilp.tutorInitialAssessment) { <div><strong>Initial assessment:</strong> {{ilp.tutorInitialAssessment}}</div> }
          @if (ilp.assessmentUsed) { <div><strong>Assessment used:</strong> {{ilp.assessmentUsed}}@if (ilp.assessmentScore != null) { ({{ilp.assessmentScore}})} </div> }
          @if (ilp.initialKeyStageCode || ilp.targetKeyStageCode) {
            <div><strong>Key stage / grade:</strong> {{ilp.initialKeyStageCode}} {{ilp.initialGradeDescription}} → {{ilp.targetKeyStageCode}} {{ilp.targetGradeDescription}}</div>
          }
          @if (ilp.areasOfStrength) { <div><strong>Areas of strength:</strong> {{ilp.areasOfStrength}}</div> }
          @if (ilp.areasForDevelopment) { <div><strong>Areas for development:</strong> {{ilp.areasForDevelopment}}</div> }
          <div class="milpr-semh">
            @for (semh of semhLabels; track semh.key) {
              @if (ilp[semh.key] != null) { <span class="milpr-semh-chip">{{semh.label}}: {{ilp[semh.key]}}</span> }
            }
          </div>
          @if (ilp.learnerComments) { <div><strong>Learner comments:</strong> {{ilp.learnerComments}}</div> }
        </div>
      }

      <h4>Progress Reports</h4>
      @if (learner.progressReports.length === 0) { <p class="milpr-empty">No progress reports in this period.</p> }
      @for (pr of learner.progressReports; track $index) {
        <div class="milpr-block">
          <div><strong>Report date:</strong> {{pr.reportDate | date:'dd/MM/yyyy'}}</div>
          <div class="milpr-semh">
            @for (semh of semhLabels; track semh.key) {
              @if (pr[semh.key] != null) { <span class="milpr-semh-chip">{{semh.label}}: {{pr[semh.key]}}</span> }
            }
          </div>
          <div><strong>Last 6 weeks:</strong> {{pr.last6WeeksSummary}}</div>
          <div><strong>Next 6 weeks:</strong> {{pr.next6WeeksPlan}}</div>
        </div>
      }

      <h4>Sessions</h4>
      @if (learner.sessions.length === 0) { <p class="milpr-empty">No sessions in this period.</p> }
      @if (learner.sessions.length > 0) {
        <div class="native-report-table-container">
          <table class="milpr-sessions-table">
            <thead>
              <tr><th>Date</th><th>Start</th><th>End</th><th>Attendance</th><th>Subject</th><th>Delivery</th><th>Engagement</th><th>Comprehension</th><th>Learning comment</th><th>Status</th></tr>
            </thead>
            <tbody>
              @for (s of learner.sessions; track $index) {
                <tr>
                  <td>{{s.startDate | date:'dd/MM/yyyy'}}</td>
                  <td>{{s.startTime | slice:0:5}}</td>
                  <td>{{s.endTime | slice:0:5}}</td>
                  <td>{{s.attendance}}{{s.reason ? ' (' + s.reason + ')' : ''}}</td>
                  <td>{{s.subject}}</td>
                  <td>{{s.sessionDelivery}}</td>
                  <td>{{s.engagement}}</td>
                  <td>{{s.comprehension}}</td>
                  <td>{{s.learningComment}}</td>
                  <td><app-session-status-pill [status]="s.status"></app-session-status-pill></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

    </div>
  }
  @if (report.learners.length === 0) {
    <div class="milpr-empty">No learners matched the selected filters.</div>
  }
}
